import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const DonationSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    return (
        <div className="donation-success__shell">
            <div className="donation-success__card">
                <FontAwesomeIcon icon={faCheckCircle} className="donation-success__icon" />
                <h1 className="donation-success__heading">Thank You for Your Donation!</h1>
                <p className="donation-success__body">
                    Your generosity makes a real difference to the Friends of Bukit Kiara community.
                </p>
                {sessionId && (
                    <p className="donation-success__reference">Reference: {sessionId}</p>
                )}
                <Button color="primary" className="donation-success__btn" onClick={() => navigate('/')}>
                    Return to Home
                </Button>
            </div>
        </div>
    );
};

export default DonationSuccess;
